import { Emitter } from 'vue'
import { EventBuss } from './constants'

export class MJWebsocket {
    /**
     *
     */
    constructor(_emitter: Emitter) {
        this.emitter = _emitter

        // listen for browser going offline to trigger close/reconnect logic immediately
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', () => {
                // mark as disconnected
                this.isConnected = false
                // force-close the socket so onclose runs and schedules reconnects
                if (
                    this.ws &&
                    this.ws.readyState !== WebSocket.CLOSING &&
                    this.ws.readyState !== WebSocket.CLOSED
                ) {
                    try {
                        this.closedByClient = false
                        this.ws.close()
                    } catch {
                        // ignore
                    }
                }
            })
        }
    }
    ws!: WebSocket
    isConnected = false
    emitter!: Emitter

    heartBeatInterval = 10000
    reconnectInterval = 3000

    heartBeat: number | boolean = false

    private url = ''

    private count = 0
    private reconnectCount = 0
    private hasRecentDataRecieved = false
    private closedByClient = false

    private isOff = false

    // OnOpen!: () => void
    OnMessage!: (event: MessageEvent) => void
    // OnClose!: (event: CloseEvent) => void
    // OnError!: (event: Event) => void

    connect(url: string): void {
        if (this.isOff) return
        // prevent duplicate connections: only block if an existing socket is OPEN or CONNECTING
        if (
            this.ws &&
            (this.ws.readyState === WebSocket.OPEN ||
                this.ws.readyState === WebSocket.CONNECTING)
        ) {
            this.isConnected = this.ws.readyState === WebSocket.OPEN
            return
        }
        // Stop previous connection's heartbeat so it does not run alongside or confuse the new one
        this.stopHeartBeat()
        // Unregister previous socket so it never fires our handlers again (no duplicate messages)
        if (this.ws) {
            this.unregisterSocketHandlers(this.ws)
        }
        this.url = url
        this.ws = new WebSocket(this.url)
        console.log('connecting to ws')

        // create an intance of websocket
        this.ws.onopen = () => {
            this.isConnected = true
            console.log('connected')

            // emit event when connection is established after a reconnect attempt
            if (this.reconnectCount > 0) {
                this.emitter.emit(EventBuss.SOCKET_RECONNECTED)
            }
            this.reconnectCount = 0

            // Re-assign onmessage on every open (including reconnect) so the current OnMessage callback is always used
            this.ws.onmessage = (event: MessageEvent) => {
                if (typeof this.OnMessage === 'function') {
                    this.count = 0
                    this.hasRecentDataRecieved = true
                    this.OnMessage(event)
                }
            }

            this.stopHeartBeat()
            this.heartBeat = setInterval(() => {
                if (this.isConnected) {
                    const pingObject = { type: 'client-ping', data: {} }
                    this.ws.send(JSON.stringify(pingObject))
                    // console.log('NO DATA', this.count)

                    if (this.count > 3) {
                        // check if need to reconect
                        if (this.hasRecentDataRecieved) {
                            this.hasRecentDataRecieved = false
                        } else {
                            this.stopHeartBeat()
                            this.close()
                            this.showMessage()
                        }

                        this.count = 0
                    }
                    this.count++
                } else {
                    this.stopHeartBeat()
                }
            }, this.heartBeatInterval)
        }

        // listen to message event
        this.ws.onmessage = (event: MessageEvent) => {
            if (typeof this.OnMessage === 'function') {
                this.count = 0
                this.hasRecentDataRecieved = true
                this.OnMessage(event)
            }
        }

        this.ws.onclose = (event: CloseEvent) => {
            this.isConnected = false
            if (!event.wasClean) {
                setTimeout(() => {
                    if (this.reconnectCount > 5) {
                        this.reconnectCount = 0
                        this.emitter.emit(EventBuss.SOCKET_RECONNECT_FAILED)
                        this.showMessage()
                    } else {
                        console.log('reconnect ws')
                        this.reconnectCount++
                        this.connect(this.url)
                    }
                }, this.reconnectInterval)
            } else {
                console.log('close')
                if (!this.closedByClient) {
                    setTimeout(() => {
                        if (this.reconnectCount > 5) {
                            this.reconnectCount = 0
                            this.emitter.emit(EventBuss.SOCKET_RECONNECT_FAILED)
                            this.showMessage()
                        } else {
                            console.log('reconnect ws')
                            this.reconnectCount++
                            this.connect(this.url)
                        }
                    }, this.reconnectInterval)
                } else {
                    this.closedByClient = false
                }
            }
        }

        this.ws.onerror = (event: Event) => {
            console.log('ws error')
            // mark as disconnected so manual reconnects are allowed
            this.isConnected = false
            // force-close so onclose handler can immediately schedule reconnects
            if (
                !this.closedByClient &&
                this.ws &&
                this.ws.readyState !== WebSocket.CLOSING &&
                this.ws.readyState !== WebSocket.CLOSED
            ) {
                try {
                    this.ws.close()
                } catch {
                    // ignore close errors
                }
            }
        }
    }

    close(): void {
        if (this.ws) {
            this.closedByClient = true
            this.stopHeartBeat()
            this.ws.close()
        }
    }

    showMessage(): void {
        // const evt: MessageBoxEvent = {
        //     type: MessageBoxActionType.open,
        //     // name: 'message'
        //     name:''
        // }
        // this.emitter.emit(EventBuss.DIALOG, evt)
        // setTimeout(() => {
        this.emitter.emit(
            EventBuss.TOAST_MESSAGE,
            '因网络波动异常，请您重新登录系统，谢谢！'
        )
        // }, 250)
    }

    private stopHeartBeat(): void {
        if (typeof this.heartBeat === 'number') {
            clearInterval(this.heartBeat)
            this.heartBeat = false
            console.log('ws heartbeat stoped')
        }
    }

    /** Remove all handlers from a socket so it no longer emits into our callbacks (use before replacing this.ws) */
    private unregisterSocketHandlers(ws: WebSocket): void {
        ws.onmessage = null
        ws.onclose = null
        ws.onerror = null
        ws.onopen = null
    }
}
